import { useState } from "react";
import { toast } from "sonner";
import { MailWarning } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function EmailVerifyNotice() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success(`Verification link sent to ${user.email}`);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-4 rounded-2xl border border-amber-500/30 bg-amber-500/10 p-5" data-testid="email-verify-notice">
      <MailWarning className="h-5 w-5 text-amber-400" />
      <p className="flex-1 text-sm text-amber-200">Please confirm your email address. We sent a link to <span className="font-mono">{user?.email}</span>.</p>
      <button onClick={resend} disabled={busy} className="btn-ghost !px-4 !py-2 text-xs" data-testid="resend-verification-button">{busy ? "Sending..." : "Resend link"}</button>
    </div>
  );
}
